import React from "react";
import SysApiLogDetailsView from "../component/SysApiLogDetailsView";

const SysApiLogDetailContainer = () => (<SysApiLogDetailsView />)

export default SysApiLogDetailContainer;